var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0L24.4318 0L44 0C47.3137 0 50 2.68629 50 6V44C50 47.3137 47.3137 50 44 50H6C2.68629 50 0 47.3137 0 44L0 6Z",
    fill: "#FB1FFF",
    fillOpacity: 0.35
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0001,
    cy: 16.4286,
    r: 5.42857,
    fill: "#8D2276",
    stroke: "#8D2276",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9766 40.226L24.3922 40.0623L23.6909 39.6883L23.1766 39.361L22.639 38.987L21.8909 38.5195L21.213 38.0519L20.3948 37.4208L19.1558 36.3221L18.3844 35.5974L17.7766 34.9896L17.239 34.2883L16.7948 33.4701L16.561 33.0961L16.4208 32.7922L16.2104 32.0442L16.0701 31.5532L16 31.226V30.3377V29.5662L16.187 29.0286L16.6545 28.1169L17.3091 27.1584L18.0104 26.5974L18.8052 25.9896L19.5766 25.639L20.3948 25.4286H21.3299L21.9143 25.5221L22.6156 25.7325L23.3636 25.9896L23.9247 26.2701L24.4623 26.5974L24.8364 26.9247L25.0234 27.0649L25.1636 26.9247L25.5143 26.5974L25.9584 26.2701L26.426 25.9896L27.0571 25.7325L27.7351 25.5221L28.4597 25.4286H29.3481L30.2831 25.639L31.1948 25.9896L32.1299 26.5974L32.7143 27.1584L33.3455 27.9532L33.813 29.0286L34 29.8234V30.9922V31.3896L33.6026 32.6987L32.8312 34.1481L32.1766 35.013L31.0779 36.1818L29.7221 37.3273L26.3325 39.6883L25.6312 40.0623L24.9766 40.226Z",
    fill: "#8D2276",
    stroke: "#8D2276",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoyalty);
export default __webpack_public_path__ + "static/media/icon-loyalty.cccdb44da92c05384bf4d1a5e6b39f13.svg";
export { ForwardRef as ReactComponent };